<template>
  <table class="season-table table table-bordered text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col" rowspan="2">
          <input type="checkbox" v-model="allSelected" class="mr-2">Id
        </th>
        <th scope="col" rowspan="2">Type</th>
        <th scope="col" rowspan="2">Audience</th>
        <th scope="col" rowspan="2">Status</th>
      </tr>
    </thead>
    <tr
      v-for="seasonContainer in seasonContainers"
      :key="seasonContainer.season.id"
    >
      <td>
        <input type="checkbox" v-model="seasonContainer.selected" class="mr-2">
        <season-link :seasonId="seasonContainer.season.id" label=""/>
      </td>
      <td>?</td>
      <td>?</td>
      <td>?</td>
    </tr>
  </table>
</template>

<script>
import SeasonLink from './SeasonLink.vue';

export default {
  name: 'SeasonTable',

  components: {
    SeasonLink,
  },

  props: {
    seasonTypeNameMap: {
      type: Map,
      required: true,
    },

    seasonContainers: {
      type: Array,
      required: true,
    },
  },

  computed: {
    allSelected: {
      get() {
        for(const container of this.seasonContainers) {
          if(!container.selected) {
            return false;
          }
        }
        return true;
      },

      set(newValue) {
        if(newValue) {
          this.selectAll();
        } else {
          this.deselectAll();
        }
      },
    },
  },

  methods: {
    selectAll() {
      this.$emit('total-selection-requested');
    },

    deselectAll() {
      this.$emit('total-deselection-requested');
    },
  },
};
</script>

<style scoped>
.season-table {
  width: 1px;
}
</style>
